import { CommonModule } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	NgModule,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

import { QuotaTypeEnum } from '@reach/interfaces/quotas/quota-type.enum';

import { QuotaService } from '~app-client/core/services';
import { ReachModalsService } from '~app-client/modals/services';
import { Implicit } from '~app-client/modals/types';

@Component({
	standalone: false,

	selector: 'nodes-exceeded',
	templateUrl: './nodes-exceeded.component.html',
	styleUrls: ['./nodes-exceeded.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'error-modals' } }],
})
export class NodesExceededComponent implements AfterViewInit {
	@ViewChild('tpl')
	private tpl: TemplateRef<Implicit<void>>;

	private readonly quotaService = inject(QuotaService);

	private readonly $quota = toSignal(this.quotaService.quotas$);

	public readonly $quotaNodes = computed(() => {
		const quota = this.$quota();
		if (!quota) {
			return null;
		}
		const { total, used } = quota[QuotaTypeEnum.NODES];
		return { total, used };
	});

	constructor(
		private readonly modalsService: ReachModalsService,
		private readonly router: Router
	) {}

	async ngAfterViewInit(): Promise<void> {
		this.modalsService.openModal(this.tpl, null, {
			closeOnOutsideClick: false,
		});

		await this.quotaService.load(true);
	}

	public async confirm(): Promise<void> {
		await this.router.navigate(['/', 'home', 'profile', 'usage'], {
			queryParams: { usagePanel: 'nodes' },
			queryParamsHandling: 'merge',
		});
		this.cancel();
	}

	public cancel(): void {
		this.modalsService.closeModal();
	}
}

@NgModule({
	declarations: [NodesExceededComponent],
	imports: [CommonModule, TranslocoModule],
	exports: [NodesExceededComponent],
})
export class NodesExceededModule {}
